import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Row, Col } from 'antd';
import FormField from './FormField';
import MaskedInput from './MaskedInput';
import SelectField from './SelectField';
import { useCepLookup } from '../../hooks/useCepLookup';
import { CEP_MASK } from '../../utils/masks';

const UF_OPTIONS = [
  'AC','AL','AM','AP','BA','CE','DF','ES','GO','MA','MG','MS','MT',
  'PA','PB','PE','PI','PR','RJ','RN','RO','RR','RS','SC','SE','SP','TO'
].map((uf) => ({ label: uf, value: uf }));

interface AddressBlockProps {
  prefix: string;
  title?: string;
}

export default function AddressBlock({ prefix, title }: AddressBlockProps) {
  const { setValue, getValues } = useFormContext();
  const { buscarCep, loading } = useCepLookup();

  const handleCepBlur = async () => {
    const cep = getValues(`${prefix}.cep`);
    if (!cep) return;
    const result = await buscarCep(cep);
    if (result) {
      setValue(`${prefix}.logradouro`, result.logradouro, { shouldValidate: true });
      setValue(`${prefix}.bairro`, result.bairro, { shouldValidate: true });
      setValue(`${prefix}.cidade`, result.cidade, { shouldValidate: true });
      setValue(`${prefix}.uf`, result.uf, { shouldValidate: true });
    }
  };

  return (
    <div className="border rounded-lg p-4 mb-4 bg-gray-50">
      {title && <h4 className="text-md font-semibold mb-3">{title}</h4>}
      <Row gutter={16}>
        <Col xs={24} sm={8}>
          <div onBlur={handleCepBlur}>
            <MaskedInput name={`${prefix}.cep`} label="CEP" mask={CEP_MASK} required />
          </div>
        </Col>
        <Col xs={24} sm={16}>
          <FormField name={`${prefix}.logradouro`} label="Logradouro" required disabled={loading} />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={6}>
          <FormField name={`${prefix}.numero`} label="Número" required />
        </Col>
        <Col xs={24} sm={8}>
          <FormField name={`${prefix}.complemento`} label="Complemento" />
        </Col>
        <Col xs={24} sm={10}>
          <FormField name={`${prefix}.bairro`} label="Bairro" required disabled={loading} />
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xs={24} sm={16}>
          <FormField name={`${prefix}.cidade`} label="Cidade" required disabled={loading} />
        </Col>
        <Col xs={24} sm={8}>
          <SelectField name={`${prefix}.uf`} label="UF" options={UF_OPTIONS} required />
        </Col>
      </Row>
    </div>
  );
}
